import Picker from "./picker/picker";
import ChartLoader from "./charts/chartloader.js";


window.addEventListener("load", function () {
    const selector = document.querySelector("#date-picker");

    if (selector == null)
        return;

    Picker.create(selector, function () {
        // called when chart updates
        ChartLoader.load();
    });

    ChartLoader.load();
});
